/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { POST } from '/client/src/api';
import Credentials from '/client/src/api/Credentials.js';
import withMeta from '/client/src/HOCs/withMeta';
import t from 'client/src/utils/i18nCheckKey';
import { ToggleOpacityOfContent } from 'client/src/utils/animation';
import BtnLoader from '/client/src/components/btns/circularProgress/';
import { useLocation } from 'react-router-dom';

const queryString = require('query-string');

type PropsType = {
  handleChangeView: (string) => void,
  toggleAuthenticateStatus: () => void
  // meta: MetaContextType
};
const CollaboratorSignUp = (props: PropsType): React.Element<typeof React.Fragment> => {

    const [ name, setName ] = React.useState('');
    const [ pass, setPass ] = React.useState('');
    const [isIncorrect, setIncorrect] = React.useState(false);
  
    const passValidationMessage = React.createRef();
    const location = useLocation();
    const { email, token } = queryString.parse(location.search);

    ToggleOpacityOfContent(1);
    window.localStorage.removeItem('user');

  
    const sendRequest = async (e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void): Promise<any> => {
      e.preventDefault();
  
      validate('name', name);
      validate('pass', pass);
  
      if (!_.size(name) || !_.size(pass)) {
        return false;
      }
      const tokenCode = token
      try {
        setStatus('loading');
        await POST('/api/v1/1/merchants/active', {
          email_address: email,
          email_confirmation_code: tokenCode,
          first_name: name,
          last_name: '',
          password: pass,
          token: tokenCode
        });
        const { user, token } = await POST('/auth', {
          email: email,
          password: pass
        });
  
        setStatus('success');
        ToggleOpacityOfContent(0);
  
        setTimeout(() => {
          Credentials.login(token, user, true);
  
          setTimeout(() => {
            props.toggleAuthenticateStatus(true);
          }, 500);
        }, 500);
      } catch (error) {
        setStatus('error');
        console.error(error);
  
        setIncorrect(error);
  
        setTimeout(() => {
          setStatus('');
        }, 5000);
      }
    };
  
  
    const validate = (key: string, value: string | null) => {
      const passWrapper = passValidationMessage.current;
  
      if (key === 'pass') {
        if (!_.size(value)) {
          passWrapper.classList.add('has-error');
          passWrapper.querySelector('input').classList.add('validationElement');
        } else {
          passValidationMessage.current.classList.remove('has-error');
          passValidationMessage.current
            .querySelector('input')
            .classList
            .remove('validationElement');
        }
      }
    };
  
    // const { t } = useTranslation();
  
    return (
      <div className="form-box-container">
        <div className="form-box-message">
        {isIncorrect &&
          <div className="alert alert-danger mt-3">
            <div data-bind="text: errorMessage">
              {email} is registered. <br/>  
              Please <Link to='/login'>login</Link> or <Link to='/sign-up'>create an account</Link>
            </div>
          </div>
        }
        </div>
        <form className="mt-5" role="form">
        <div className="mt-4">
            <label htmlFor="email">Work email address</label>
            <input
                className="form-control validationElement"
                type="input"
                id="email"
                value={email}
                readOnly={true}
                style={{color: '#a1a1a1'}}
              />
          </div>
          <div className="mt-4">
            <label htmlFor="name">Your name</label>
            <input
                className="form-control validationElement"
                type="input"
                title="This field is required."
                id="name"
                value={name}
                onChange={(e: SyntheticEvent<HTMLInputElement>) => {
                  setName(e.target.value);
                }}
              />
          </div>
  
          <div className="mt-4">
            <div className="pswd-label">
              <label htmlFor="password">Password</label>
            </div>
            <div ref={passValidationMessage}>
              <input
                className="form-control validationElement"
                type="password"
                title="This field is required."
                id="password"
                value={pass}
                onChange={(e: SyntheticEvent<HTMLInputElement>) => {
                  setPass(e.target.value);
  
                  validate('pass', e.target.value);
                }}
              />
              <span
                className="validationMessage"
              >This field is required.</span>
            </div>
          </div>

          <br/>
  
          <div className="row">
            <div className="col-xs-12 text-center progress-button-50">
              <BtnLoader
                label="Let's Collaborate!"
                handleCallBack={(e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void) => {
                  sendRequest(e, setStatus);
                }}
              />
            </div>
          </div>
        </form>
      </div>
    );
  };

export default CollaboratorSignUp;
